/**
 * A ordem da lista de menções (2026-10-02) — espelho de
 * `core.vocabulary.MENTION_ORDERS`, com paridade travada por
 * `tests/test_mention_order_parity.py` (lê este arquivo, inclusive a
 * SEQUÊNCIA, que é a ordem do `<select>`). A tupla é `as const` e o mapa
 * de rótulos é tipado sobre ela de propósito: chave a menos ou a mais é
 * erro de compilação, não uma opção sem nome na tela.
 *
 * "Canal / Fonte" é o nome da coluna da lista — no banco é `channel` do
 * post, e é o que a galera de negócio chama de "veículo".
 */

export const MENTION_ORDERS = [
  "published_desc",
  "published_asc",
  "title_asc",
  "title_desc",
  "channel_asc",
  "channel_desc",
  "tier_desc",
  "tier_asc",
  "interactions_desc",
  "interactions_asc",
  "icena_desc",
  "icena_asc",
  "ad_value_desc",
  "ad_value_asc",
  "reach_desc",
  "reach_asc",
  "content_asc",
  "content_desc",
  "discarded_desc",
  "discarded_asc"
] as const;

export type MentionOrder = (typeof MENTION_ORDERS)[number];

export const MENTION_ORDER_DEFAULT: MentionOrder = "published_desc";

export const MENTION_ORDER_LABELS: Record<MentionOrder, string> = {
  published_desc: "Mais recentes",
  published_asc: "Mais antigas",
  title_asc: "Título A–Z",
  title_desc: "Título Z–A",
  channel_asc: "Canal / Fonte A–Z",
  channel_desc: "Canal / Fonte Z–A",
  tier_desc: "Tier (melhor primeiro)",
  tier_asc: "Tier (pior primeiro)",
  interactions_desc: "Mais interações",
  interactions_asc: "Menos interações",
  icena_desc: "CENA maior",
  icena_asc: "CENA menor",
  ad_value_desc: "Valoração maior",
  ad_value_asc: "Valoração menor",
  reach_desc: "Alcance maior",
  reach_asc: "Alcance menor",
  content_asc: "Texto A–Z",
  content_desc: "Texto Z–A",
  discarded_desc: "Descartadas há menos tempo",
  discarded_asc: "Descartadas há mais tempo"
};

/**
 * Ordens pela data do descarte: só valem sobre descartadas (sem descarte
 * toda chave é NULL e a ordem seria só o id). A página Lixeira as usa, e o
 * `<select>` de menções só as oferece com "Só as descartadas" ligado.
 */
export const TRASH_ORDERS: readonly MentionOrder[] = [
  "discarded_desc",
  "discarded_asc"
];

/** Pra ler o `localStorage` sem confiar no que está lá. */
export function isMentionOrder(value: unknown): value is MentionOrder {
  return (
    typeof value === "string" &&
    (MENTION_ORDERS as readonly string[]).includes(value)
  );
}
